import isLikeNull from './isLikeNull';

export function convertToNullOrValidNumber(
  value: string | null,
): number | null {
  const number = Number(value);
  if (isNaN(number) || isLikeNull(value)) {
    return null;
  }
  return number;
}
